import React, { useEffect } from "react";
import Dialog from "../Dialog/Dialog";
import FileInput from "../FileInput/FileInput";

export default function EntityUploadDialog({ open, onClose, uploadService, entityLabel }) {
  
  const [resetSignal, setResetSignal] = React.useState(0);
  const handleClose_ = () => { 
    setResetSignal((prev) => prev + 1); // triggers clearInput 
    onClose();
  };
  // Close on Escape
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        handleClose_();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <Dialog open={open} onClose={handleClose_}>{/* onClose will keep upload progress */}
      <h2>Upload {entityLabel}</h2>

      <h3>Single file</h3>
      <FileInput
        isBulk={false}
        resetSignal={resetSignal}
        labelSingle={`Upload ${entityLabel}`}
        accept=".xlsx"
        uploadService={uploadService}
        onUploadComplete={(status) => console.log("Single file status:", status)}
      />

      <h3>Bulk upload</h3>
      <FileInput
        isBulk={true}
        resetSignal={resetSignal}
        labelBulk="Select folder"
        uploadService={uploadService}
        onUploadComplete={(status) => console.log("Bulk upload status:", status)}
      />

      <div style={{ marginTop: 16 }}>
        <button className="label-btn" 
          style={{ "--label-btn-color": "#43A047" }}
          onClick={onClose}>Close</button>
      </div>
    </Dialog>
  );
}
